import * as ng from 'angular';
import { AccountApi, ViewTypes, WebhostingApi } from '@/types';
import { DomainTypes } from '@/atomic-components/organs';
import { WizardNewHelperService } from '@/services';

export class OrganismDomainWizardExternalProductConfigController {
    public static $inject: string[] = ['$timeout', 'wizardNewHelper'];

    public metadata: ViewTypes.ProductConfigDomainVhostObject;
    public profiles: unknown;
    public webspace: WebhostingApi.Webspace;
    public domainType: DomainTypes;
    public formCompleted = {
        dnsRecordsUpdater: false,
        vhost: false
    };

    private _account: AccountApi.Account | AccountApi.Subaccount;
    private _webspaceOrig: WebhostingApi.Webspace;
    private _vhost: WebhostingApi.VHost;
    private _domainList: unknown;
    private _reloadDnsRecordPanel: boolean;

    constructor(
        private $timeout: ng.ITimeoutService,
        private wizardNewHelper: WizardNewHelperService
    ) {}

    public $onInit(): void {
        this._webspaceOrig = ng.copy(this.webspace);
        this._setMetadata();
    }

    public $doCheck(): void {
        if ([undefined, null].indexOf(this.metadata.vhost) < 0
            && this.metadata.vhost.domainName !== this._vhost?.domainName
        ) {

            void this.$timeout(() => this._reloadDnsRecordPanel = false);
            this._vhost = ng.copy(this.metadata.vhost);
            this._domainList = [
                {
                    domainName: this._vhost.domainName,
                    domainNameUnicode: this._vhost.domainNameUnicode
                }
            ];
            void this.$timeout(() => this._reloadDnsRecordPanel = true);
        }
    }

    /* eslint-disable-next-line no-empty-pattern, @typescript-eslint/no-empty-function */
    public set configCompleted({}) {}
    public get configCompleted(): boolean {
        return Object.values(this.formCompleted).every((part) => part);
    }

    public get showWebspaceSelection(): boolean {
        return !this._webspaceOrig;
    }

    public get reloadDnsRecordPanel(): boolean {
        return this._reloadDnsRecordPanel;
    }

    /* eslint-disable-next-line no-empty-pattern, @typescript-eslint/no-empty-function */
    public set enableDnsSettingPanel({}) {}
    public get enableDnsSettingPanel(): boolean {
        return this.metadata.webspace !== undefined
            && this.formCompleted.vhost
            && this.metadata.vhost !== undefined;
    }

    public get domainList(): unknown {
        if (!this.metadata?.vhost) {
            return undefined;
        }

        return this._domainList;
    }

    private _setMetadata = (): void => {
        this.metadata = {
            account: this._account,
            defaultLocation: null,
            domainType: DomainTypes.EXTERNAL,
            dns: {
                type: 'webspace',
                values: {
                    ip: null,
                    masterIp: null,
                    mxServer: null,
                    records: [],
                    replacements: {
                        ipv4Replacement: undefined,
                        ipv6Replacement: undefined,
                        mxipv4Replacement: undefined,
                        mxipv6Replacement: undefined
                    },
                    templateChain: false,
                    templateId: null
                }
            },
            phpIniDefaults: null,
            profiles: this.profiles,
            records: null,
            vhost: null,
            webspace: this.webspace,
            zoneUpdateData: null
        };

        this.metadata.dns.values = this.wizardNewHelper.setDnsSettings(
            this.metadata
        )  as ViewTypes.ProductConfigDomainVhostObjectDnsValue;
    };
}

export class OrganismDomainWizardExternalProductConfigComponent implements ng.IComponentOptions {
    public bindings = {
        _account: '<account',
        configCompleted: '=',
        metadata: '=',
        profiles: '<?',
        domainType: '<',
        webspace: '<?'
    };
    public template = require('./domain-wizard-external-config.html');
    public controller = OrganismDomainWizardExternalProductConfigController;
}
